module.exports = __webpack_public_path__ + "img/bath3.67e41761.jpeg";